import { set as lodashSet } from 'lodash-es'
import { get as lodashGet } from 'lodash-es'

export const set = lodashSet
export const get = lodashGet